export interface Article {
  id: string;
  title: string;
  description: string;
  category: "getting-started" | "advanced";
  isLocked: boolean;
  readTime: string;
}

export const articles: Article[] = [
  // Free articles
  {
    id: "how-to-sign-up-as-turo-host",
    title: "How to Sign Up as a Turo Host",
    description: "Step-by-step guide to creating your Turo host account and getting approved.",
    category: "getting-started",
    isLocked: false,
    readTime: "12 min",
  },
  {
    id: "how-much-can-you-make",
    title: "How Much Can You Make",
    description: "Realistic earnings expectations and factors that affect your income.",
    category: "getting-started",
    isLocked: false,
    readTime: "15 min",
  },
  {
    id: "renting-out-your-personal-car",
    title: "Renting Out Your Personal Car",
    description: "Pros and cons of starting with your personal vehicle.",
    category: "getting-started",
    isLocked: false,
    readTime: "12 min",
  },
  {
    id: "buy-your-first-turo-car",
    title: "Buy Your First Turo Car",
    description: "What to look for when purchasing a dedicated rental vehicle.",
    category: "getting-started",
    isLocked: false,
    readTime: "8 min",
  },
  {
    id: "how-protection-plans-work",
    title: "How Protection Plans Work",
    description: "Understanding Turo's protection options and what they cover.",
    category: "getting-started",
    isLocked: false,
    readTime: "14 min",
  },
  {
    id: "how-to-list-your-first-car",
    title: "How to List Your First Car",
    description: "Creating an optimized listing that attracts bookings.",
    category: "getting-started",
    isLocked: false,
    readTime: "15 min",
  },
  {
    id: "checkin-checkout-process",
    title: "Check-in/Check-out Process",
    description: "Best practices for smooth guest handoffs and documentation.",
    category: "getting-started",
    isLocked: false,
    readTime: "14 min",
  },
  {
    id: "my-first-rental",
    title: "My First Rental! What to Do",
    description: "How to handle your first guest rental smoothly and confidently.",
    category: "getting-started",
    isLocked: false,
    readTime: "12 min",
  },
  {
    id: "will-you-have-any-renters",
    title: "Will You Have Any Renters?",
    description: "Getting your first booking and understanding Turo demand.",
    category: "getting-started",
    isLocked: false,
    readTime: "8 min",
  },
  // Locked articles
  {
    id: "cleaning-equipment-starter-kit",
    title: "Cleaning Equipment Starter Kit",
    description: "Essential supplies and tools for maintaining your fleet.",
    category: "advanced",
    isLocked: true,
    readTime: "12 min",
  },
  {
    id: "damage-claims",
    title: "Damage Claims",
    description: "How to document damage and navigate the claims process successfully.",
    category: "advanced",
    isLocked: true,
    readTime: "15 min",
  },
  {
    id: "discounting-techniques",
    title: "Discounting Techniques",
    description: "Strategic pricing to maximize bookings and revenue.",
    category: "advanced",
    isLocked: true,
    readTime: "10 min",
  },
  {
    id: "advanced-protection-plan-techniques",
    title: "Advanced Protection Plan Techniques",
    description: "Optimizing your protection strategy for different scenarios.",
    category: "advanced",
    isLocked: true,
    readTime: "12 min",
  },
  {
    id: "advanced-calendar-techniques",
    title: "Advanced Calendar Techniques",
    description: "Managing availability, pricing rules, and trip gaps effectively.",
    category: "advanced",
    isLocked: true,
    readTime: "14 min",
  },
  {
    id: "scaling-with-creative-financing",
    title: "Scaling with Creative Financing",
    description: "Funding strategies for growing your fleet beyond cash purchases.",
    category: "advanced",
    isLocked: true,
    readTime: "18 min",
  },
  {
    id: "llc-setup",
    title: "LLC Setup",
    description: "Structuring your business for liability protection and tax benefits.",
    category: "advanced",
    isLocked: true,
    readTime: "15 min",
  },
  {
    id: "commercial-insurance",
    title: "Commercial Insurance",
    description: "Understanding and obtaining proper coverage for your rental business.",
    category: "advanced",
    isLocked: true,
    readTime: "12 min",
  },
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((article) => article.id === id);
};

export const getFreeArticles = (): Article[] => {
  return articles.filter((article) => !article.isLocked);
};

export const getLockedArticles = (): Article[] => {
  return articles.filter((article) => article.isLocked);
};
